module.exports = __webpack_public_path__ + "static/media/betamax.ff12c4e9.svg";